import styled, { css } from 'styled-components';
import { CtaButton } from '@getgrover/ui';

import Plus from 'ggApp/shared/icons/CleanPlus';

import BundleProductCard from './BundleProductCard';

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 0;
`;

export const Header = styled.h2`
    color: ${(props) => props.theme.colors.Foreground};
    ${({ theme }) => theme.typography.Headline};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        ${theme.typography.Subheadline}
    `};
    margin-bottom: 16px;

    u a {
        color: #FE1251;
        text-decoration: underline;
    }
`;

export const ProductGrid = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(14, 1fr);
    grid-auto-rows: min-content;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    margin-bottom: 16px;
`;

export const MainProduct = styled(BundleProductCard)`
    grid-column: 1 / span 6;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        grid-column: 1 / -1;
    `};
    height: 100%;
`;

export const BundleProductsWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    grid-column-start: ${({ bundleProductsQty }) => (bundleProductsQty > 1 ? 8 : 9)};
    grid-column-end: 15;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        grid-column: 1 / -1;
    `};
    height: 100%;
`;

export const BundleProduct = styled(BundleProductCard)`
    &:not(:last-child) {
        margin-bottom: 8px;
    }
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-bottom: 0;
    `};
    height: 100%;
`;

export const PlusSeperator = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    grid-column-start: 7;
    grid-column-end: ${({ bundleProductsQty }) => (bundleProductsQty > 1 ? 8 : 9)};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        grid-column: 1 / -1;
    `};
    ${({ withMargin }) => withMargin && css`
        margin: 16px 0;
    `};
`;

export const PlusIcon = styled(Plus)`
    height: 24px;
    width: 24px;
`;

export const PriceWrap = styled.div`
    display: flex;
    margin-bottom: 16px;
    align-items: flex-end;
`;

export const OldPrice = styled.h2`
    ${({ theme }) => css(theme.typography.Paragraph)};
    text-decoration: line-through;
    margin-right: 4px;
    display: inline;
`;

export const CurrentPrice = styled.h2`
    margin-right: 4px;
    display: inline;
    ${({ theme }) => css(theme.typography.Subheadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    line-height: 30px;
    white-space: nowrap;
    &::before {
        content: ' ';
    }
    ${({ withOldPrice, theme }) => withOldPrice
        && css`
            color: ${theme.colors.Color1};
            &::before {
                content: '';
            }
        `}
`;

export const PlanDescription = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Button = styled(CtaButton)`
    width: 100%;
    margin-bottom: 16px;
    ${({ theme }) => theme.superQuery.all.and.minWidth.tabletMin.css`
        width: 272px;
    `};
`;
